var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { applyWPSProxyUrl } from "../common.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { setAuthHeader } from "../utils.js";
const TAGS = {
  VNEXT_ANALYSIS: "VNextAnalysis"
};
const vnextAnalysisApiBaseQuery = (args, api, extraOptions) => __async(void 0, null, function* () {
  const baseUrl = applyWPSProxyUrl(EnvironmentService.endpoints.expanalysis.url);
  const rawBaseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => __async(void 0, null, function* () {
      yield setAuthHeader({ tokenScope: EnvironmentService.endpoints.default.tokenScope }, headers);
      headers.set("Cache-Control", "no-cache");
      return headers;
    })
  });
  return rawBaseQuery(args, api, extraOptions);
});
export {
  TAGS,
  vnextAnalysisApiBaseQuery
};
//# sourceMappingURL=common.js.map
